/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ country: NonNullable<unknown> }} Community_Curator_Empty_PromptInputs */



/**
* | output |
* | --- |
* | "Nothing pinned for {country} yet — pin community links, or add official channels of your own." |
*
* @param {Community_Curator_Empty_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_curator_empty_prompt = /** @type {((inputs: Community_Curator_Empty_PromptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Curator_Empty_PromptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rien d’épinglé pour ${i?.country} pour le moment — épinglez des liens de communauté, ou ajoutez vos propres canaux officiels.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Todavía no hay nada fijado en ${i?.country} — fija enlaces de comunidad, o añade tus propios canales oficiales.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Nada fixado em ${i?.country} ainda — fixe links de comunidade, ou adicione seus próprios canais oficiais.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ancora nulla di fissato per ${i?.country} — fissa dei link di comunità, o aggiungi canali ufficiali tuoi.`)
	return /** @type {LocalizedString} */ (`Nothing pinned for ${i?.country} yet — pin community links, or add official channels of your own.`)
});